import { ABTestVariant } from "../models";
import {
  GET_ALL_VARIANTS,
  GET_VARIANT_BY_ID,
  UPDATE_VARIANT,
  UpdateOrDeleteResponseBody,
} from "../utils/constant";
import { getJson, putJson } from "../utils/network";

export async function getVariantById(
  variantId: string,
  sendSlotName = true,
): Promise<ABTestVariant> {
  const path = GET_VARIANT_BY_ID(variantId, sendSlotName);
  const { response } = await getJson<ABTestVariant>(path);

  return response as ABTestVariant;
}

export async function getAllVariants(
  conditionId: string,
  slotNo: number,
  excludeWidgets: boolean,
): Promise<ABTestVariant[]> {
  const path = GET_ALL_VARIANTS(conditionId, slotNo, excludeWidgets);
  const { response } = await getJson<ABTestVariant[]>(path);

  return response as ABTestVariant[];
}

export async function updateVariant(data: { conditionId: string; slotId: string; status?: boolean }) {
  const path = UPDATE_VARIANT;
  const { response } = await putJson<UpdateOrDeleteResponseBody>(
    path,
    Object.fromEntries(Object.entries(data).filter(([key, value]) => value != null || value !== undefined)),
  );

  return response;
}
